import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class ProcessVessels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diameter: '',
      diameter2: '',
      height: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeDiameter = this.handleChange.bind(null, 'diameter');
    this.handleChangeDiameter2 = this.handleChange.bind(null, 'diameter2');
    this.handleChangeHeight = this.handleChange.bind(null, 'height');
  }
  handleChange(key, value) {
    const onCalc = this.props.onCalc;
    this.setState({
      [key]: value
    }, () => {
      const _this$state = this.state,
        diameter = _this$state.diameter,
        diameter2 = _this$state.diameter2,
        height = _this$state.height,
        amount = _this$state.amount;
      if (diameter !== '' && diameter2 !== '' && height !== '' && amount !== '') {
        // Calculate the surface area
        let total = 3.14 * diameter * height + 2 * diameter2 ** 2;
        total *= amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const _this$state2 = this.state,
      diameter = _this$state2.diameter,
      diameter2 = _this$state2.diameter2,
      height = _this$state2.height,
      amount = _this$state2.amount;
    const result = this.props.result;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "((3.14 x Diameter x Height) + (2 x Diameter", /*#__PURE__*/React.createElement("sup", null, "2"), ")) x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameter,
      value: diameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Height",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeHeight,
      value: height
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Diameter\xB2",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameter2,
      value: diameter2
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
ProcessVessels.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};
ProcessVessels.defaultProps = {
  onCalc: null,
  result: null
};